import { useState, useCallback } from "react";
import { Listing } from "src/types/listing";
import { useInkedCardPreviewUrl } from "./useInkedCardPreviewUrl";

export const useViewSentCards = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const { mutateAsync: getPreviewUrl, isPending: isLoading } =
    useInkedCardPreviewUrl();

  const viewSentCards = useCallback(
    async (listing: Listing) => {
      setPreviewUrl(null);
      setIsOpen(true);

      try {
        const externalId = `${listing.productType}:${listing.id}`;
        const url = await getPreviewUrl(externalId);
        setPreviewUrl(url);
      } catch (error) {
        console.error("Failed to get card preview URL:", error);
      }
    },
    [getPreviewUrl]
  );

  const closeDialog = useCallback(() => {
    setIsOpen(false);
    setPreviewUrl(null);
  }, []);

  return {
    viewSentCards,
    closeDialog,
    isOpen,
    previewUrl,
    isLoading,
  };
};
